<template>
  <PageTitleComponent
    v-if="range && range.label"
    :title="range.label.toUpperCase()"
  />
  <div v-if="vehicle" class="vehicle">
    <div class="vehicle__img">
      <img
        :alt="
          vehicle.vehicle_label + (displayLabel() ? ' ' + vehicle.label : '')
        "
        :src="imageManager().picture(vehicle.mobile_photo, 'zoom')"
      />
      <router-link
        v-if="vehicle.gallery && vehicle.gallery.length"
        :to="{
          name: 'Gallery',
          params: { range: range.id, vehicle: vehicle.id },
        }"
        class="button vehicle__button"
      >
        <img src="/assets/images/svg/icone-diaporama.svg" />
        {{
          vehicle.vehicle_label +
          " " +
          vehicle.label +
          " " +
          getTranslation(506)
        }}
      </router-link>
    </div>
    <div v-if="vehicle.motors && vehicle.motors[0]" class="right">
      <div class="right__content">
        <div class="right__title">
          <h1 class="right__label">
            <span class="e-aixam me-2" v-html="processVehicleLabel()"></span>
            <template v-if="displayLabel()">{{ vehicle.label }}</template>
          </h1>
          <div class="right__energy">
            {{ vehicle.motors[0].label }}
          </div>
        </div>
        <PinsComponent />
        <VehicleTabsComponent />
      </div>
    </div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import { mapActions, mapState } from "pinia";
import VehicleTabsComponent from "@/components/VehicleTabs/VehicleTabsComponent.vue";
import PinsComponent from "@/components/PinsComponent.vue";
import { vehicleManager } from "@/services/vehicle-manager";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";
import { imageManager } from "@/services/image-manager";

export default {
  name: "VehicleView",
  components: {
    PinsComponent,
    VehicleTabsComponent,
    PageTitleComponent,
  },
  computed: {
    ...mapState(useMainStore, {
      ranges: (store) => store.ranges,
      range: (store) => store.range,
      vehicle: (store) => store.vehicle,
    }),
  },
  watch: {
    ranges() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    imageManager() {
      return imageManager;
    },
    init() {
      this.toggleRange(this.$route.params.range);
      this.toggleVehicle(this.$route.params.vehicle);
    },

    displayLabel() {
      return (
        this.vehicle &&
        this.vehicle.vehicle_label &&
        !this.vehicle.vehicle_label.includes(this.vehicle.label)
      );
    },

    processVehicleLabel() {
      return vehicleManager.processLabel(this.vehicle.vehicle_label);
    },

    getTranslation(id, params = {}) {
      return getTranslation(id, params);
    },

    ...mapActions(useMainStore, ["toggleRange", "toggleVehicle"]),
  },
};
</script>

<style lang="scss" scoped>
.vehicle {
  color: $white;
  height: 100%;
  width: 42%;
  position: relative;

  &__img {
    height: 100%;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center left;
    }
  }

  &__button {
    position: absolute;
    bottom: 100px;
    left: 16%;
    padding: 10px 45px;

    img {
      width: 40px;
      margin-right: 15px;
    }
  }
}

.right {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 64%;
  color: $blue;

  &:before {
    content: "";
    background: $grey;
    position: absolute;
    top: 0;
    right: -50%;
    width: 150%;
    height: 100%;
    transform: skewX($skew);
    z-index: -1;
  }

  &__content {
    padding-left: 130px;
    padding-top: 65px;
    height: 100%;
  }

  &__title {
    border-left: 1px solid $blue;
    padding-left: 20px;
  }

  &__label {
    font-size: 40px;
    text-transform: uppercase;
    font-weight: 700;
    line-height: 0.8;
    margin-bottom: 20px;
  }

  &__energy {
    font-size: 20px;
    line-height: 0.8;
  }
}
</style>
